import { CommonModule } from '@angular/common';
import { Component, effect, inject, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PortfolioSeries } from 'src/app/models/classes/portfolio-series.class';
import { CurrencyFormatPipe } from 'src/app/pipes/currency-format.pipe';
import { IrrValueFormatPipe } from 'src/app/pipes/irr-value-format.pipe';
import { TvpiValueFormatPipe } from 'src/app/pipes/tvpi-value-format.pipe';
import { TvpiIrrFormatService } from 'src/app/services/tvpi-irr-format.service';

@Component({
    selector: 'app-series-summary-card',
    imports: [CommonModule, MatTooltipModule, CurrencyFormatPipe, TvpiValueFormatPipe, IrrValueFormatPipe],
    templateUrl: './series-summary-card.component.html',
    styleUrl: './series-summary-card.component.scss',
})
export class SeriesSummaryCardComponent {
    private tvpiIrrFormat = inject(TvpiIrrFormatService);

    readonly currency = input.required<string>();
    readonly seriesSummary = input.required<PortfolioSeries>();
    readonly iconSet = input.required<Record<string, string>>();
    noResultsSeries = true;

    private readonly deriveIrrAndTvpi = effect(() => {
        if (this.seriesSummary()) {
            this.noResultsSeries = false;
            this.getSeriesIrrAndTvpiValues();
        }
    });

    getSeriesIrrAndTvpiValues() {
        const seriesSummary = this.seriesSummary();
        const iconSet = this.iconSet();
        this.tvpiIrrFormat.deriveIrrAndTvpiIconAndTitle(
            seriesSummary.qoQIrrChange,
            seriesSummary?.irr ?? 0,
            seriesSummary?.priorIrr ?? 0,
            iconSet,
            seriesSummary
        );
        this.tvpiIrrFormat.deriveIrrAndTvpiIconAndTitle(
            seriesSummary.qoQTvpiChange,
            seriesSummary?.tvpi ?? 0,
            seriesSummary?.priorTvpi ?? 0,
            iconSet,
            seriesSummary,
            true
        );
    }
}
